/* eslint no-use-before-define: 0 */

import jQuery from "jquery";
import {
    newSearchDone$,
    searchRequested$,
    fireMouseLeftTileContainer,
    fireMouseEnteredTile,
    fireTileListReloaded,
} from "@sharedFrontend/globalEvents";

import SecurityService from "@security/Services/SecurityService";

(function main($) {
    $(document).ready(() => {
        const tileListContainer = $(".tile-list-container");

        searchRequested$.subscribe(() => {
            tileListContainer.html("<div class=\"loader\"></div>");
        });

        newSearchDone$.subscribe(ids => loadTileList(ids));

        function createRequestData(result) {
            return JSON.stringify({
                ids: result.pages,
                rent: result.rent,
                typeSettingsId: tileListContainer.data("types"),
                renderingParameters: tileListContainer.data("rendering-parameters"),
                databaseName: tileListContainer.data("database"),
                languageName: tileListContainer.data("language"),
                isExperienceEditor: tileListContainer.data("experience-editor"),
            });
        }

        function loadTileList(result) {
            return new Promise((resolve) => {
                if (tileListContainer.length === 0) {
                    return;
                }

                $.ajax({
                    url: "/api/ObjectsApi/GetTileListHtml",
                    datatype: "html",
                    data: createRequestData(result),
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    beforeSend: xhr => xhr.setRequestHeader("__RequestVerificationToken", SecurityService.CSRFToken),
                }).done((response) => {
                    tileListContainer.empty();
                    if (response && response.length !== 0) {
                        tileListContainer.append(response);
                        bindMouseEventListeners();
                        resolve(true);
                        fireTileListReloaded();
                    }
                });
            });
        }

        function bindMouseEventListeners() {
            bindTileMouseEntersListeners();
            bindContainerMouseleaveListener();
        }

        function bindTileMouseEntersListeners() {
            const tiles = $(".tile");
            tiles.mouseenter(function callFireEvent() {
                fireMouseEnteredTile($(this).data("id"));
            });
        }

        function bindContainerMouseleaveListener() {
            const container = $(".tile-list-container");
            container.off("mouseleave");
            container.mouseleave(() => fireMouseLeftTileContainer());
        }
    });
}(jQuery));
